import { Observable } from 'rxjs';
import { UseCase } from '@domain/base/use-case';
import { CartRepository } from '@domain/models/cart/gateway/cart-repository';
import { Archetype, Lego } from '@domain/models/task/task';

export class GetAllFromCartUseCase
  implements UseCase<void, (Lego | Archetype)[]>
{
  constructor(private readonly _cartRepository: CartRepository) {}

  execute(): Observable<(Lego | Archetype)[]> {
    return this._cartRepository.getTasks();
  }
}
